import React, { useState } from "react";
import "../../../../../../Assets/Styles/IdentityField.scss";
import Spinner from "../../../../../../Assets/Images/EclipseSpinner.svg";
import Close from "../../../../../../Assets/Images/x-circle.svg";
import axios from "axios";

const IdentityField = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [Results, setResults] = useState([]);
  const [ResultIsOpen, setResultIsOpen] = useState(false);
  const [ItemSelected, setItemSelected] = useState(false);
  const [User, setUser] = useState({});

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleInputChange = (e) => {
    let Value = e.target.value;
    let CommaCount = Value.split(",").length - 1; // returns the number of "," used in the value of the input

    document.getElementById("input-text").innerHTML = e.target.value;

    if (Value.length === 0) {
      document.getElementById("name-placeholder").style.display = "block";
      document.getElementById("position-placeholder").style.display = "block";
      document.getElementById("country-placeholder").style.display = "block";
      setResultIsOpen(false);
    }

    if (Value.length > 0) {
      document.getElementById("name-placeholder").style.display = "none";
    } else {
      document.getElementById("name-placeholder").style.display = "block";
    }

    if (Value.length >= 5) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }

    if (CommaCount === 1 && Value.length > Value.lastIndexOf(",")) {
      document.getElementById("position-placeholder").style.display = "none";
      document.getElementById("country-placeholder").style.display = "block";
    }

    if (CommaCount === 1 && Value.length === parseInt(Value.lastIndexOf(","))) {
      document.getElementById("position-placeholder").style.display = "block";
    }

    if (CommaCount === 0) {
      document.getElementById("position-placeholder").style.display = "block";
      document.getElementById("country-placeholder").style.display = "block";
    }
    if (CommaCount === 2 && Value.length > Value.lastIndexOf(",")) {
      document.getElementById("country-placeholder").style.display = "none";
    }

    updatePosPlaceholder();
    updateValues(e.target.value);
  };

  const updateValues = (Value) => {
    let CommaCount = Value.split(",").length - 1; // returns the number of "," used in the value of the input
    let NameValue;
    var PosValue;
    var CountryValue;

    if (CommaCount === 0) {
      NameValue = Value;
      PosValue = "";
      CountryValue = "";
    }
    if (CommaCount === 1) {
      NameValue = Value.slice(0, Value.indexOf(","));
      PosValue = Value.slice(Value.indexOf(","), Value.length);
      CountryValue = "";
    }
    if (CommaCount === 2) {
      NameValue = Value.slice(0, Value.indexOf(","));
      PosValue = Value.slice(Value.indexOf(",") + 1, Value.lastIndexOf(","));
      CountryValue = Value.slice(Value.lastIndexOf(",") + 1, Value.length);
    }
    getData(
      NameValue.replace(",", ""),
      PosValue.replace(",", ""),
      CountryValue.replace(",", "")
    );
  };

  const getData = (NameValue, PosValue, CountryValue) => {
    if (
      parseInt(NameValue.length + PosValue.length + CountryValue.length) >= 5
    ) {
      let Data = {
        criteria: {
          nameLike: NameValue,
        },
      };
      if (PosValue.length > 1) {
        Data.criteria.positionLike = PosValue;
      } else {
        delete Data.criteria.positionLike;
      }
      if (CountryValue.length > 1) {
        Data.criteria.countryLike = CountryValue;
      } else {
        delete Data.criteria.countryLike;
      }
      let Req = {
        method: "POST",
        baseURL:
          window._env_.API_URL +
          "/employee-service/api/employee/search-for-identity",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: Data,
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setResults(Res.data.results);
          setIsLoading(false);
          setResultIsOpen(true);
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };

  const updatePosPlaceholder = () => {
    let Distance =
      parseInt(document.getElementById("input-text").clientWidth) + "px";
    document.getElementById("placeholder").style.left = Distance;
  };

  const handleKeyPress = (e) => {
    let CommaCount =
      document.getElementById("identity").value.split(",").length - 1;

    if (CommaCount >= 2 && e.key === ",") {
      e.preventDefault(); // won't let users enter more than 2 "," characters
    }
  };

  const selectItem = (User) => {
    setUser(User);
    setItemSelected(true);
    setResultIsOpen(false);
    document.getElementById("username").value = User.email;
    props.EnableSave();
  };

  const clear = () => {
    setItemSelected(false);
    document.getElementById("identity").value = "";
    document.getElementById("name-placeholder").style.display = "block";
    document.getElementById("placeholder").style.left = "0";
    document.getElementById("username").value = "";
    props.RemoveError();
  };

  return (
    <React.Fragment>
      {ResultIsOpen ? (
        <div className="outline" onClick={() => setResultIsOpen(false)}></div>
      ) : null}
      <p id="input-text"></p>
      <div className="identity-field">
        <input
          id="identity"
          onKeyPress={(e) => handleKeyPress(e)}
          onChange={(e) => handleInputChange(e)}
          onClick={() => props.RemoveError()}
          autoComplete="off"
        />
        <section id="placeholder" className="placeholder">
          <p className="placeholder-text" id="name-placeholder">
            {props.NamePlaceholder}
          </p>
          <p className="placeholder-text" id="position-placeholder">
            {props.PosPlaceholder}
          </p>
          <p className="placeholder-text" id="country-placeholder">
            {" " + props.CountryPlaceholder}
          </p>
        </section>
        <p className="info" id="identity-info">
          {translateText("character_limit_warning")}
        </p>
        {IsLoading ? <img id="spinner" alt="" src={Spinner} /> : null}
        {ItemSelected ? (
          <div className="selected-overlay">
            <p>{User.firstName + " " + User.lastName}</p>
            <img onClick={() => clear()} id="clear-btn" alt="" src={Close} />
          </div>
        ) : null}
        {ResultIsOpen ? (
          <div className="results">
            {Results.length === 0 ? (
              <p className="empty-text">No results found</p>
            ) : (
              Results.map((Result) => (
                <section onClick={() => selectItem(Result)}>
                  <h3>{Result.firstName + " " + Result.lastName}</h3>
                  <h5>
                    {Result.positionName === null
                      ? "Not specified"
                      : Result.positionName}{" "}
                    <p>|</p>
                    {Result.countryName === null
                      ? "Not specified"
                      : Result.countryName}
                  </h5>
                </section>
              ))
            )}
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default IdentityField;
